import type { Balances } from "../model";

export const getUSDTBalance = (balances: Balances | undefined) => {
  const asset = balances?.find(({ asset }) => asset === "USDT");
  return [asset?.balance ?? 0, Number(asset?.rubBalance ?? 0)];
};
export const getFTCOINBalance = (balances: Balances | undefined) => {
  return balances?.find(({ asset }) => asset === "FT_COIN")?.balance ?? 0;
};
